import { jsx as o } from "react/jsx-runtime";
import { Container as l, SelectableListItem as c } from "./style.js";
const a = ({
  listItems: t,
  selectedItemId: r,
  onSelectItem: i
}) => /* @__PURE__ */ o(l, { children: t.map((e) => /* @__PURE__ */ o(
  c,
  {
    icon: e.icon,
    text: e.title,
    role: "radio",
    onClick: () => i(e.id),
    selected: e.id === r
  },
  e.id
)) });
export {
  a as SelectableList
};
